var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');

var resource = Object.create(Model);

resource.name = 'Resource';
resource['@class'] = 'Resource';
resource.url = 'resource';

resource.fields = {
  parent: {
    default: null
  },
  name: {
    default: null,
    validators: {
      presence: true,
      length: {minimum: 3, maximum: 128, default: ''}
    }
  },
  interval: {
    default: 0,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo: 0
      },
      samplingInterval: true
    }
  },
  suppressAuditNotifications: {
    default: 0
  },
  disableAdminAuditNotifications: {
    default: 0
  },
  disableReceiverAuditNotifications: {
    default: 0
  },
  suppressAuditNotificationsExpiresAt: {
    default: null
  },
};

resource.initForm();

resource.view = function () {
  return  m('form', {role:'form'}, [
    resource.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        type:'text', 
        onchange: function(ev){resource.form.name(ev.target.value)},
        value: resource.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'type-input'}, 'Interval'),
      m('input.form-control', {
        id:'node-input', 
        autocomplete: 'off',
        type:'number', 
        onchange: function(ev){resource.form.interval(ev.target.value)},
        value: resource.form.interval(),
      })
    ])
  ])  
}

module.exports = resource;
